// Native
import { useState } from "react"

// Components
import { AlertDialogBody, AlertDialogFooter, Button, ButtonGroup, Divider, useDisclosure, useToast } from "@chakra-ui/react"
import { Alert, Dialog, Label } from "components"

// Config
import { API } from "config"

// Screens
import { Authenticate } from "screens"

export default function Delete({ data, onSuccess = () => {}, ...props }){
    
    const toast = useToast()
    const auth = useDisclosure()
    const [ loading, setLoading ] = useState(false)

    const onSubmit = async () => {
        setLoading(true)

        try{
            await API.delete(`/customers/${data?.consultant?.customer?.id}/addresses/${data?.address?.id}`)
            toast({ title: 'Endereço removido', status: 'info' })
            onSuccess()
            props?.onClose()
        }catch(err){
            toast({ title: 'Não foi possível remover o endereço agora.', description: err?.response?.data?.message, status: 'warning' })
        }

        setLoading(false)
    }

    return (
    <>
        <Dialog title="Tem certeza que deseja remover este endereço?" loading={loading} {...props}>
            <AlertDialogBody>
                <Alert status="warning" children="Esta ação é irreversível. Para remover um endereço de cliente, não pode haver pedidos associados à este endereço." />
                <Divider my={4} />
                <Label label="Endereço:" children={`${data?.address?.line_1} ${data?.address?.line_2 ?? ''} ${data?.address?.complement ?? ''}`} />
            </AlertDialogBody>
            <AlertDialogFooter>
                <ButtonGroup size="sm" isDisabled={loading}>
                    <Button isLoading={loading} children="Remover endereço" onClick={auth.onOpen} />
                    <Button children="Cancelar" colorScheme="red" onClick={props.onClose} />
                </ButtonGroup>
            </AlertDialogFooter>
        </Dialog>

        <Authenticate {...auth} onSuccess={onSubmit} />
    </>
    )
}